import React, { useState, useEffect, useMemo, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import NumberInputBox from "../../../CustomComponents/AllCustomeInput/NumberInputBox";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import CustomReactQuill from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import axiosInstance from "../../../../redux/api";
import { getCategary, getSubcategary } from "../../../../redux/categary/action";
import PortfolioImages from "../Productsforsell/PortfolioImages";
import { descriptionvalidation, filesvalidationforstatusbase, nospecialtitle, titlevalidation } from "../../../Common/commonvalidation";
import AsteriskLabel from "../../../Common/AsteriskLabel";

const bxpDatatomap = [
  { title: (<>Product title <AsteriskLabel /></>), name: "title", placeholder: "Type here" },
  { title: (<>Minimum bid <AsteriskLabel /></>), name: "min_bid", placeholder: "Enter Price" },
  { title: (<>Cover photo <AsteriskLabel /></>), name: "files", placeholder: "Drag and drop or Browse file" },
  { title: (<>Description <AsteriskLabel /></>), name: "description", placeholder: "Type here" },
];

const SyncParent = ({ values, setbxpData, updateindex, initialValues, setChangesIsThere }) => {
  const lastSynced = useRef("");
  const initialSnapshot = useRef(null);

  if (initialSnapshot.current === null) {
    initialSnapshot.current = JSON.stringify(initialValues);
  }

  useEffect(() => {
    const currentValues = JSON.stringify(values);
    if (lastSynced.current !== currentValues) {
      if (updateindex === null && Object.keys(values).length > 0) {
        setbxpData((prev) => ({ ...prev, ...values }));
      }
      const hasChanges = currentValues !== initialSnapshot.current;
      setChangesIsThere(hasChanges);
      lastSynced.current = currentValues;
    }
  }, [values, updateindex, setbxpData, setChangesIsThere]);
  return null;
};

const Productdetails = ({ updateindex, bxpData, setbxpData, setActiveTab, setChangesIsThere }) => {
  const [selectSubcategory, setSelectSubcategory] = useState([]);
  const [selectCatgory, setselectCatgory] = useState([]);
  const [loading, setLoading] = useState(null);
  
  // NEW: State to track image upload loading status
  const [isImageUploading, setIsImageUploading] = useState(false); 
  
  const [images, setImages] = useState([]);
  const [selectCategory, setSelectCategory] = useState(null);
  const [subcategory, setSubcategory] = useState([]);
  const [parentid, setParentid] = useState("");
  const [category, setCategory] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (updateindex) {
      setImages([]);
    }
  }, [updateindex]);

  const initialValues = useMemo(() => {
    return {
      title: bxpData?.title || "",
      cover: bxpData?.cover || "",
      files: bxpData?.files || "",
      min_bid: bxpData?.min_bid || "",
      description: bxpData?.description || "",
    };
  }, [bxpData]);

  const validationSchema = Yup.object().shape({
    title: nospecialtitle,
    files: filesvalidationforstatusbase,
    min_bid: Yup.number().required("This is required").moreThan(0, "Price should be more than zero"),
    description: descriptionvalidation,
  });

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
    dispatch(getCategary());
  }, [path]);

  const categarylist = useSelector(({ categary: { categarylist } }) => categarylist);

  useEffect(() => {
    if (parentid) {
      axiosInstance.get(`category?type=3&parent_id=${parentid}`).then((response) => {
        setSubcategory(response?.data?.response);
      });
    }
  }, [parentid]);

  const handleSubmit = async (values) => {
    setLoading(true);
    let updatedData = { ...bxpData, ...values };

    try {
      setbxpData(updatedData);
      setActiveTab("WorkSamples");
    } catch (error) {
      urtoast(error.message, 2);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    if (bxpData?.category_id && categarylist?.length) {
      const selectedCategory = categarylist.find((item) => item.id == bxpData?.category_id);
      setselectCatgory(selectedCategory ? { value: selectedCategory.id, label: selectedCategory.title } : null);
      setParentid(bxpData?.category_id);
    } else if (updateindex == null) {
      setselectCatgory(null);
    }
  }, [updateindex, bxpData?.category_id, categarylist]);

  // Sync form values to parent state for drafts
  useEffect(() => {
    // This is now handled by SyncParent
  }, []);

  useEffect(() => {
    setCategory(categarylist);
  }, [categarylist]);

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              <SyncParent
                values={formik.values}
                setbxpData={setbxpData}
                updateindex={updateindex}
                initialValues={initialValues}
                setChangesIsThere={setChangesIsThere}
              />
              <div>
                {bxpDatatomap.map((prop, key) => {
                  if (prop.name == "description") {
                    return (
                      <React.Fragment key={key}>
                        <CustomReactQuill
                          value={formik.values[prop.name]}
                          formik={formik}
                          name={prop.name}
                          title={prop.title}
                        />
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className="error"
                          style={{ color: "red" }}
                        />
                      </React.Fragment>
                    );
                  }
                  if (prop.name == "category_id") {
                    return (
                      <div className="form-group" key={key}>
                        <label>{prop.title}</label>
                        <ReactSelect
                          options={
                            Array.isArray(category) &&
                            category.map((lang) => ({
                              value: lang.id,
                              label: lang.title,
                            }))
                          }
                          placeholder={prop.placeholder}
                          value={selectCatgory}
                          onChange={(options) => {
                            setselectCatgory(options);
                            setParentid(options.value);
                            setSelectSubcategory("");
                            formik.setFieldValue("category_index", options);
                            formik.setFieldValue(prop.name, options.value);
                            formik.setFieldValue("subcategory_index", "");
                            formik.setFieldValue("sub_category_id", "");
                          }}
                        />
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className="error"
                        />
                      </div>
                    );
                  }

                  if (prop.name == "min_bid") {
                    return (
                      <NumberInputBox
                        title={prop.title}
                        name={prop.name}
                        placeholder={prop.placeholder}
                        key={key}
                      />
                    );
                  }
                  if (prop.name == "sub_category_id") {
                    return (
                      <div className="form-group" key={key}>
                        <label>{prop.title}</label>
                        <ReactSelect
                          options={
                            Array.isArray(subcategory) &&
                            subcategory.map((lang) => ({
                              value: lang.id,
                              label: lang.title,
                            }))
                          }
                          placeholder="Select An Option"
                          value={selectSubcategory}
                          onChange={(options) => {
                            setSelectSubcategory(options);
                            formik.setFieldValue("sub_category_id", options.value);
                            formik.setFieldValue("subcategory_index", options);
                          }}
                        />
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className="error"
                        />
                      </div>
                    );
                  }
                  if (prop.name == "files") {
                    return (
                      <div 
                        className="form-group upload-item-images" 
                        key={key}
                        style={{ position: "relative" }}
                      >
                        <label className="d-block mb-2">{prop.title}</label>
                        
                        {/* NEW: Loader overlay for file uploading */}
                        {isImageUploading && (
                          <div 
                            style={{
                              position: "absolute",
                              top: 0, left: 0, right: 0, bottom: 0,
                              backgroundColor: "rgba(255, 255, 255, 0.7)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              zIndex: 10,
                              borderRadius: "8px"
                            }}
                          >
                            <LoginLoaderButton />
                            <span style={{ marginLeft: "10px", fontWeight: "500" }}>Uploading...</span>
                          </div>
                        )}

                        <PortfolioImages
                          selectedfiles={formik.values.files}
                          setWork_sample={(files) => formik.setFieldValue("files", files)}
                          formik={formik}
                          doctype={1}
                          setIsImageUploading={setIsImageUploading} // Pass this so PortfolioImages can trigger the loader
                        />

                        <ul className="border-ul mt-2">
                          <li>Images (JPG, PNG, JPEG up to 10MB)</li>
                        </ul>
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className="error"
                          style={{ color: "red" }}
                        />
                      </div>
                    );
                  }

                  return (
                    <FieldInput
                      title={prop.title}
                      name={prop.name}
                      placeholder={prop.placeholder}
                      key={key}
                    />
                  );
                })}
                
                <div className="button-container mt-4">
                  <button 
                    className="next-button w-100" 
                    type="submit" 
                    disabled={loading || isImageUploading} // Prevent submission while uploading
                  >
                    {loading ? <LoginLoaderButton /> : "Next"}
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default Productdetails;